import { useT } from '@transifex/react'
import SlackLogo from '../images/SlackLogo.png'

const SlackIcon: React.FC = () => {
  const t = useT()
  return (
    <img src={SlackLogo} alt={t('Slack')} style={{ width: 39, height: 39, objectFit: 'contain' }} />
  )
}

export default SlackIcon
